export default __webpack_public_path__ + "static/media/cv.2e6112f6.pdf";